'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sha512 = undefined;

var _sha = require('crypto-js/sha512');

var _sha2 = _interopRequireDefault(_sha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sha512 = exports.sha512 = function sha512(str) {
  return (0, _sha2.default)(str).toString();
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/utils/crypto.js
// module id = 521
// module chunks = 1